module.exports = __webpack_public_path__ + "static/media/awair-logo.d264536f.png";